export function getOrderImportRoute(dataId: string): {
  path: string
  query: { data_id: string }
} {
  return {
    path: '/materialList',
    query: { data_id: dataId },
  }
}
